import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_FINANCIAL_SUMMARY: createSagaAction('GET_FINANCIAL_SUMMARY'),
  FINANCIAL_SUMMARY_UPDATE: createSagaAction('FINANCIAL_SUMMARY_UPDATE')
}

// Action Creators
export const actions = {
  getJobFinancialSummary: ({ jobId }) => ({
    type: constants.GET_FINANCIAL_SUMMARY.ACTION,
    jobId
  }),

  updateJobFinancialSummary: ({ jobId, userId, content }) => ({
    type: constants.FINANCIAL_SUMMARY_UPDATE.ACTION,
    jobId,
    userId,
    content
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_FINANCIAL_SUMMARY.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_FINANCIAL_SUMMARY.SUCCESS:
      return {
        ...state,
        jobFinancialSummary: action.payload
      }
    case constants.GET_FINANCIAL_SUMMARY.FAILED:
      return {
        error: action.message
      }
    case constants.FINANCIAL_SUMMARY_UPDATE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobFinancialSummaryActions.js